import * as React from 'react';
import { UnderDevelopment } from '../../../../../components';
import { UnscrollableContainer } from '../../../../../misc';

export const Dashboard = (): JSX.Element => {
  return (
    <UnscrollableContainer className="flex flex-col justify-center items-center">
      <UnderDevelopment />
    </UnscrollableContainer>
  );
};
